import React from 'react'
import { CsWarningIcon } from '../../legacy-design-system/icons'
import { WithTooltip, tooltipTitleCss } from '../../design-system'
import { FormattedMessage } from 'react-intl'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { listResetCss } from '../../legacy-design-system/list'
import { RoleSwitch, Role } from '../roles'
import { css } from '@emotion/css'
import { Link } from '@contrast-security-inc/design-system-typography'

interface PolicyViolation {
  readonly name: string
  readonly id: string
}

interface Props {
  readonly organizationID: string
  readonly organizationRole: Role
  readonly violations: PolicyViolation[]
}

const iconSize = 15

export function PolicyViolationTooltipContent({
  organizationID,
  organizationRole,
  violations
}: Props) {
  return (
    <div
      className={css`
        max-width: 260px;
      `}
    >
      <FormattedMessage
        id="title_attention"
        children={(text) => <div className={tooltipTitleCss} children={text} />}
      />
      <FormattedMessage id="detail_remediationPolicyTraceViolation_violationOfPoliciesSet" />
      <ul className={listResetCss}>
        {violations.map(({ id, name }, violationIndex) => (
          <li
            key={violationIndex}
            className={css`
              display: inline;
            `}
          >
            <RoleSwitch
              requiredRole="RULES_ADMIN"
              role={organizationRole}
              renderAllowed={() => (
                <React.Fragment>
                  <Link
                    className={css`
                      display: inline-block;
                      color: ${theme.color.turquoise50} !important;
                    `}
                    href={`#/${organizationID}/rules/vulnerability-management/policy/edit/${id}`}
                  >
                    {name}
                  </Link>
                  {violationIndex < violations.length - 1 && (
                    <span
                      className={css`
                        margin-right: 5px;
                      `}
                    >
                      ,
                    </span>
                  )}
                </React.Fragment>
              )}
              renderDenied={() => <span children={name} />}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}

export function PolicyViolation({
  organizationID,
  organizationRole,
  violations
}: Props) {
  return (
    <WithTooltip
      placement="right"
      renderTooltipContent={() => (
        <PolicyViolationTooltipContent
          organizationID={organizationID}
          organizationRole={organizationRole}
          violations={violations}
        />
      )}
      children={({ ref, onMouseEnter, onMouseLeave }) => (
        <span ref={ref} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
          <CsWarningIcon
            width={iconSize}
            height={iconSize}
            className={css`
              transform: translateY(-1px);
              cursor: pointer;
            `}
            color={theme.color.red50}
          />
        </span>
      )}
    />
  )
}
